import React from 'react';
import { Compass, ArrowRight, Home, ShoppingBag, PhoneCall } from 'lucide-react';

interface NotFoundPageProps {
  onNavigate: (page: string, productId?: string) => void;
}

export const NotFoundPage: React.FC<NotFoundPageProps> = ({ onNavigate }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-20 sm:py-28 text-center space-y-8">
      <div className="w-20 h-20 mx-auto rounded-3xl bg-sky-100/70 border border-sky-200 text-sky-600 flex items-center justify-center shadow-xs">
        <Compass className="w-10 h-10 animate-spin-slow" />
      </div>

      <div className="space-y-3 max-w-lg mx-auto">
        <span className="text-xs font-bold tracking-widest text-sky-600 uppercase">
          404 Error · Page Not Found
        </span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight">
          Looking for Equipment or Machinery?
        </h1>
        <p className="text-base text-slate-600 leading-relaxed">
          The link or page you requested does not exist or has been moved. Explore our commercial Water Purification Systems, Milk ATMs, and Vending Machines below.
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-4 pt-2">
        <button
          onClick={() => onNavigate('products')}
          className="inline-flex items-center gap-2 px-6 py-3.5 bg-sky-600 hover:bg-sky-700 text-white rounded-xl text-sm font-bold shadow-sm transition-all cursor-pointer"
        >
          <ShoppingBag className="w-4 h-4" />
          <span>Browse All Equipment</span>
          <ArrowRight className="w-4 h-4 ml-1" />
        </button>

        <button
          onClick={() => onNavigate('home')}
          className="inline-flex items-center gap-2 px-6 py-3.5 bg-white hover:bg-slate-100 text-slate-700 border border-slate-300 rounded-xl text-sm font-bold transition-all cursor-pointer"
        >
          <Home className="w-4 h-4 text-slate-500" />
          <span>Return Home</span>
        </button>

        <a
          href="tel:+254727072393"
          className="inline-flex items-center gap-2 px-6 py-3.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-xl text-sm font-bold transition-all cursor-pointer"
        >
          <PhoneCall className="w-4 h-4 text-emerald-600" />
          <span>Call Support (+254 727 072 393)</span>
        </a>
      </div>
    </div>
  );
};
